"use client";

import { getAvatar } from "../helper";

export type DashboardOverviewProps = {
  studentsData: studentData[];
  isVisible: boolean;
};

export type studentData = {
  id: number;
  name: string;
  class: string;
  easy: number;
  medium: number;
  hard: number;
  wordsSpoken: number;
  wordsDrawn: number;
  lastPractice: string;
};

const DashboardOverview = (props: {
  studentsData: DashboardOverviewProps["studentsData"];
  isVisible: boolean;
}) => {
  const { studentsData, isVisible } = props;

  return (
    <div
      className={`bg-white/30 backdrop-blur-lg rounded-3xl shadow-2xl border border-white/40 overflow-hidden transform transition-all duration-1000 delay-600 ${
        isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
      }`}
    >
      <div className="p-6">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-slate-300">
                <th className="text-left py-4 px-4 font-semibold text-slate-700">
                  Student
                </th>
                <th className="text-center py-4 px-4 font-semibold text-slate-700">
                  Class
                </th>
                <th className="text-center py-4 px-4 font-semibold text-slate-700">
                  Easy
                </th>
                <th className="text-center py-4 px-4 font-semibold text-slate-700">
                  Medium
                </th>
                <th className="text-center py-4 px-4 font-semibold text-slate-700">
                  Hard
                </th>
                <th className="text-center py-4 px-4 font-semibold text-slate-700">
                  Words Spoken
                </th>
                <th className="text-center py-4 px-4 font-semibold text-slate-700">
                  Words Drawn
                </th>
                <th className="text-center py-4 px-4 font-semibold text-slate-700">
                  Last Practice
                </th>
              </tr>
            </thead>
            <tbody>
              {studentsData.map((student, index) => (
                <tr
                  key={student.id}
                  className="hover:bg-white/20 transition-all duration-300 group"
                  style={{
                    animationDelay: `${index * 200}ms`,
                    animation: isVisible
                      ? "slideInUp 0.6s ease-out forwards"
                      : "none",
                  }}
                >
                  <td className="py-4 px-4">
                    <div className="flex items-center gap-3">
                      <div
                        className={`w-10 h-10 ${getAvatar(
                          student.name
                        )} rounded-full flex items-center justify-center text-white font-semibold shadow-lg group-hover:scale-110 transition-transform duration-300`}
                      >
                        😊
                      </div>
                      <span className="font-medium text-slate-800">
                        {student.name}
                      </span>
                    </div>
                  </td>
                  <td className="py-4 px-4 text-center text-slate-700 font-medium">
                    {student.class}
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full font-medium">
                      {student.easy}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full font-medium">
                      {student.medium}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full font-medium">
                      {student.hard}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span
                      className={`px-3 py-1 rounded-full font-medium ${
                        student.wordsSpoken > 0
                          ? "bg-blue-100 text-blue-700"
                          : "bg-gray-100 text-gray-500"
                      }`}
                    >
                      {student.wordsSpoken}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className="bg-purple-100 text-purple-700 px-3 py-1 rounded-full font-medium">
                      {student.wordsDrawn}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-center">
                    <span className="bg-slate-100 text-slate-700 px-3 py-2 rounded-lg font-medium border border-slate-300">
                      {student.lastPractice}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DashboardOverview;
